module.exports = __webpack_public_path__ + "static/on-trails-16129da01045254aa43d7aa30cfed570.jpg";